import { render, staticRenderFns } from "./CadredevieTab.vue?vue&type=template&id=07d0989b&"
import script from "./CadredevieTab.vue?vue&type=script&lang=js&"
export * from "./CadredevieTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports